import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Steps, Icon, Tabs, Popover, Select, Modal, Tooltip } from 'antd';
import moment from 'moment';
import { getCadenceOption, getCadenceOptionIcon, isWeekend } from './helpers';
import CadenceDropdown from './CadenceDropdown';
import HandleAddDate from './handleAddDate';

// Configure Portuguese locale for proper day names
moment.updateLocale("pt-br", {
  weekdays: ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"],
  weekdaysShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
  weekdaysMin: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"]
});
moment.locale('pt-br');

const { Step } = Steps;

const stepStyle = {
    marginBottom: 60,
};


const Cadence = ({
    type,
    data,
    cadenceData,
    setcadenceData,
}) => {
    console.log(data);

    const user = useSelector(state => state.user);
    const usersById = useSelector(state => state.usersById);

    const [activeKey, setActiveKey] = useState(null);

    const firstPendingTab = cadenceData.data.find(cadence => cadence.status === 'pending');

    const groupedCadence = cadenceData.data.reduce((acc, cadence) => {
        const date = cadence.date;
        if (!acc[date]) {
            acc[date] = [];
        }
        acc[date].push(cadence);
        return acc;
    }, {});


    useEffect(() => {
        if (firstPendingTab) {
            setActiveKey(firstPendingTab.date);
        }
    }, [firstPendingTab]);

    if(cadenceData.data.length === 0) {
        return null;
    }

    return (
        <div>
            <Tabs 
                activeKey={activeKey} 
                type="editable-card"
                style={{ backgroundColor: '#fff'}}
                onChange={(key) => setActiveKey(key)}
                hideAdd
                onEdit={(targetKey, action) => {
                    if (action === 'remove') {
                        Modal.confirm({
                            title: 'Deseja realmente excluir?',
                            content: 'Essa ação não pode ser desfeita.',
                            okText: 'Sim',
                            okType: 'danger',
                            cancelText: 'Não',
                            onOk() {
                                setcadenceData(cadenceData.filter(c => c.date !== targetKey));
                                setActiveKey(cadenceData.find(cadence => cadence.status === 'pending') ? cadenceData.find(cadence => cadence.status === 'pending').date : cadenceData[cadenceData.length - 1].date);
                            }
                        });
                    }}
                }
                tabBarExtraContent={<HandleAddDate 
                    groupedCadence={groupedCadence} 
                    cadenceData={cadenceData} 
                    setcadenceData={setcadenceData}
                    setActiveKey={setActiveKey} 
                />}
            >
            {Object.keys(groupedCadence).map((date, index) => {
                const allDone = groupedCadence[date].every(cadence => cadence.status === 'done');
                const dateObj = moment(date, 'DD/MM/YYYY');
                const isBusinessDay = !isWeekend(dateObj);
                
                // Check if any task in this date group has adjustment info
                const hasAdjustments = groupedCadence[date].some(cadence => 
                    cadence.adjustmentInfo && cadence.adjustmentInfo.wasAdjusted
                );
                
                return (
                    <Tabs.TabPane 
                        tab={
                            <Tooltip 
                                title={
                                    hasAdjustments ? 
                                    `Data ajustada automaticamente para ${dateObj.format('dddd')}` : 
                                    (isBusinessDay ? dateObj.format('dddd') : "Fim de semana - considere reagendar")
                                }
                            >
                                <span style={{ color: allDone ? '#28a745' : '' }}>
                                    <Icon type={allDone ? "check" : "calendar"} style={{ color: allDone ? '#28a745' : '' }} /> 
                                    {dateObj.format('DD/MM')}
                                    {hasAdjustments && <Icon type="info-circle" style={{ marginLeft: 4, color: '#1890ff' }} />}
                                    {!isBusinessDay && <Icon type="warning" style={{ marginLeft: 4, color: '#faad14' }} />}
                                </span>
                            </Tooltip>
                        } 
                        key={date}
                        closable={!allDone}
                        style={{ backgroundColor: '#fff'}}
                    >
                        <Steps 
                            size="small" 
                            current={groupedCadence[date].findIndex(cadence => cadence.status === 'pending')} 
                            direction={groupedCadence[date].length > 4 ? 'vertical' : 'horizontal'}
                            style={stepStyle}>
                            {groupedCadence[date].map((cadence, index) => (
                                <Step 
                                    key={index}
                                    title={
                                        <Popover content={
                                            <div>
                                                <Select defaultValue={`${cadence.type}`} style={{ width: '100%' }} onChange={(value) => {
                                                    setcadenceData({
                                                        ...cadenceData,
                                                        data: cadenceData.data.map(c => {
                                                            if (c.uid === cadence.uid) {
                                                                c.type = value;
                                                            }
                                                            return c;
                                                        })
                                                    });
                                                }}>
                                                    {[0,1,2,3,4,5].map(key => (
                                                        <Select.Option key={key} value={key}>
                                                            <Icon type={getCadenceOptionIcon(key)} /> {getCadenceOption(key)}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </div>
                                        } title="Alterar" trigger="hover">
                                            <Icon type={getCadenceOptionIcon(cadence.type)} /> {getCadenceOption(cadence.type)}
                                        </Popover>
                                    }
                                    description={
                                        <div>
                                            <CadenceDropdown 
                                                cadence={cadence} 
                                                cadenceData={cadenceData} 
                                                setcadenceData={setcadenceData} 
                                                user={user}
                                                usersById={usersById}
                                            />
                                        </div>
                                    } 
                                />
                            ))}
                        </Steps>
                    </Tabs.TabPane>
                );
            })}
            </Tabs>
        </div>
    );
};

export default Cadence;